export const mutations = {
  setBids: (state, data) => (state.bids = data),
  setSuggestions: (state, data) => (state.suggestions = data),
}
